import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';

const Header = () => {
  const { t, i18n } = useTranslation();
  const [otherLng, setOtherLng] = useState(i18n.language === 'en' ? 'fr' : 'en');

  const toggleLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setOtherLng(otherLng === 'en' ? 'fr' : 'en');
  }


  return (
    <header className="header">
      <div className='content-container'>
        <div className='btn-container'>
          <button 
            className='btn-link'
            onClick={() => {toggleLanguage(otherLng)}}
          >
            { otherLng === 'en' ? t('header.en') : t('header.fr') }
          </button>
        </div>
        <div className='title-container'>
          <div className='title-row'>
            <h1 className='title'><span className='txt-bold'>Marie</span> Baudlot</h1>
            <span className='divider'>-</span>
            <h2 className='subtitle'>{t('header.title')}</h2>
          </div>
          <p className='tagline'>{t('header.subtitle')}</p>
        </div>
      </div>
    </header>
  );
};

export default Header;